import {
    Autocomplete,
    Box,
    Dialog,
    Divider,
    TextField,
    Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { MasterSchemeInterface } from "../../../schemes/family_enquiries/family_enquiry_list";
import { useSurveysFilterStore } from "../../../../store/use-surveys-filter-store";
import {
    FilterDialogFooter,
    FilterDialogHeader,
} from "../../../users/components/filter_dialog/filter_dialog_parts";

interface FilterChoicesForChoiceInterface {
    // openchoicesModel: boolean;
    // setOpenChoicesModal: (val: boolean) => void;
    // startDate: string;
    // setStartDate: (value: string) => void;
    // endDate: string;
    // setEndDate: (value: string) => void;
    // resetFilter: () => void;
    // validFrom: string;
    // setValidFrom: (value: string) => void;
    // validTo: string;
    // setValidTo: (value: string) => void;
}

export default function FilterChoicesForChoice({
    // openchoicesModel,
    // setOpenChoicesModal,
    // setStartDate,
    // endDate,
    // setEndDate,
    // resetFilter,
    // validFrom,
    // validTo,
    // setValidFrom,
    // setValidTo

}: FilterChoicesForChoiceInterface) {


    const {
        openChoicesModal,
        setOpenChoicesModal,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        validFrom,
        setValidFrom,
        validTo,
        setValidTo,
        resetFilter,
    } = useSurveysFilterStore();

    const [_endDate, _setEndDate] = useState<string>(endDate);
    const [_startDate, _setStartDate] = useState<string>(startDate);
    const [_validTo, _setValidTo] = useState(validTo);
    const [_validFrom, _setValidFrom] = useState(validFrom)

    const handleApply = () => {
        setStartDate(_startDate);
        setEndDate(_endDate);
        setValidFrom(_validFrom);
        setValidTo(_validTo);
        setOpenChoicesModal(false);
    };

    const handleReset = () => {
        resetFilter();
        _setEndDate("");
        _setStartDate("");
        _setValidFrom("");
        _setValidTo("");
        setOpenChoicesModal(false);
    };

    return (
        <Dialog open={openChoicesModal} onClose={() => setOpenChoicesModal(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ width: 400, p: 2 }}>
                <FilterDialogHeader
                    title="Filter Surveys"
                    onClose={() => setOpenChoicesModal(false)}
                    onReset={handleReset}
                />
                <Box sx={{ maxHeight: 400, overflow: "auto scroll" }}>
                    {_dateRange({
                        title: "Date Range",
                        setEndDate: _setEndDate,
                        setStartDate: _setStartDate,
                        startDate: _startDate,
                        endDate: _endDate,
                    })}
                    {_dateRange({
                        title: "Survey Valid Range",
                        setEndDate: _setValidTo,
                        setStartDate: _setValidFrom,
                        startDate: _validFrom,
                        endDate: _validTo,
                        range_one_title: "Valid From",
                        range_two_title: "Valid To",
                        disableFutureDate: false
                    })}
                    <FilterDialogFooter onCancel={() => setOpenChoicesModal(false)} onApply={handleApply} />
                </Box>
            </Box>
        </Dialog>
    );

    function _dropdownOption({
        title,
        placeholder,
        options,
        selectedId,
        onSelect,
    }: {
        title: string;
        placeholder: string;
        options: { id: number; value: string }[];
        selectedId: number | null;
        onSelect: (id: number | null) => void;
    }) {
        return (
            <Box pt={2} pb={1}>
                <Typography fontSize={16} fontWeight="600">
                    {title}
                </Typography>
                <Box pt={1} pb={2} display="flex" flexDirection="row">
                    <Autocomplete
                        fullWidth
                        // multiple
                        value={options?.find((option) => selectedId === option?.id)}
                        onChange={(e, value) => {
                            onSelect(value?.id || null);
                        }}
                        options={options}
                        getOptionLabel={(option) => option?.value}
                        // defaultValue={[{ title: "The Godfather", year: 1972 }]}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={placeholder}
                                placeholder={placeholder}
                            />
                        )}
                    />
                </Box>
                <Divider />
            </Box>
        );
    }

    function _dateRange({
        title,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        range_one_title,
        range_two_title,
        disableFutureDate = true
    }: {
        title: string;
        startDate: string;
        setStartDate: (value: string) => void;
        endDate: string;
        setEndDate: (value: string) => void;
        range_one_title?: string,
        range_two_title?: string,
        disableFutureDate?: boolean
    }) {
        return (
            <Box pt={0} pb={1}>
                <Typography fontSize={16} fontWeight="600">
                    {title}
                </Typography>
                <Box pt={1} pb={2} display="flex" flexDirection={"column"}>
                    <DatePicker
                        label={range_one_title ? range_one_title : "Start Date"}
                        format="DD-MM-YYYY"
                        disableFuture
                        value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setStartDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fill: "#990099", // Replace with your desired color
                            },
                        }}
                    />
                    <Box p={1}></Box>
                    <DatePicker
                        label={range_two_title ? range_two_title : "End Date"}
                        format="DD-MM-YYYY"
                        disableFuture={disableFutureDate}
                        value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setEndDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fill: "#990099", // Replace with your desired color
                            },
                        }}
                    />
                </Box>
            </Box>
        );
    }
}
